import PropTypes from 'prop-types';

import React from 'react';

import { Divider, Skeleton, Space } from 'antd';
import { v4 } from 'uuid';

import { Layout } from '../../Components/Common';
import CustomHeader from '../../Components/Common/CustomHeader';
import Uploader from '../../Components/Common/Uploader2';
import Loading from '../purchase-request/Loading';

const AsyncBulkUpload = ({ title, uploadersProp, button, info, loading, tag, menuKey, group = null, after = null }) => {
  return (
    <Layout openGroup={!group ? ['bulkUploaders', 'return_order'] : group} selected={menuKey}>
      <CustomHeader tag={tag} title={title} />
      <Divider />
      {loading ? (
        <Skeleton />
      ) : (
        <Space direction="vertical">
          {uploadersProp?.map((uploader) => {
            const { items, message } = uploader;
            return (
              <React.Fragment key={v4()}>
                {uploader?.loading ? (
                  <Loading />
                ) : (
                  <Space direction="vertical" style={{ marginTop: 16 }}>
                    <Uploader items={items} message={message} />
                  </Space>
                )}
              </React.Fragment>
            );
          })}
          {after}
        </Space>
      )}
      <Space className="btns-container">
        {button}
        {info}
      </Space>
    </Layout>
  );
};

AsyncBulkUpload.propTypes = {
  title: PropTypes.string.isRequired,
  uploadersProp: PropTypes.arrayOf(Object).isRequired,
  button: PropTypes.node.isRequired,
  info: PropTypes.node.isRequired
};

export default AsyncBulkUpload;
